module.exports = __webpack_public_path__ + "static/media/how-was-it-made.b8ae9edc.md";